module.exports = __webpack_public_path__ + "img/15.b94e418b.jpg";